export const CHANGE_COND_SPECIF_DATA = "CHANGE_COND_SPECIF_DATA";
export const CHANGE_STREETS_HOUSE = "CHANGE_STREETS_HOUSE";
export const CHANGE_FLOORS_BUILDING = "CHANGE_FLOORS_BUILDING";
export const CHANGE_BLOCKS_CONDOMINIUM = "CHANGE_BLOCKS_CONDOMINIUM";
export const SET_FORM_CONDOMINIUM_SPECIFICATIONS = "SET_FORM_CONDOMINIUM_SPECIFICATIONS";
export const SET_LOADING_CONDOMINIUM_SPECIFICATIONS = "SET_LOADING_CONDOMINIUM_SPECIFICATIONS";

